import { css } from '@emotion/react';

export const modalStyle = css`
  min-width: min(90vw, 800px);
`;
